<template>
  <div>
    <h2 class="col-lg-12 text-center mb-3">Editar lugar</h2>
    <FormPlace :basePlace="place" @submit-requested="submitRequested"></FormPlace>
  </div>
</template>
 
<script>
import { mapState, mapActions } from 'vuex'
import FormPlace from '../forms/FormPlace.vue'
import router from '@/router';

  export default {
  components: { FormPlace },
    computed:{
      ...mapState('places', ['placeOutput']),
      place: function()
      {
        return this.placeOutput && this.placeOutput.obj ? this.placeOutput.obj.place : null;
      }
    },
    methods: {
      ...mapActions('places', ['editPlace']),
      ...mapActions('places', ['getPlace']),
      submitRequested (place) {
        this.editPlace(place);
      },
    },
    mounted: function()
    {
      if(!this.$route.params.id)
      {
        router.push({ path: '/locais/lista' });
      }
      else
      {
        this.getPlace(this.$route.params.id);
      }
    }
  }
</script> 
 
<style scoped>
</style> 